/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import "../styles/ForgotPassword.css";
import '../styles/WebsiteStyle.css';
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useUser } from "../store/hooks/useUser";
import { LoginVerificationCode, ReSendVerificationCodeEmail } from "../services/login.service";
import { useAppContext } from "../contexts/AppContext";
import { Constants } from "../constants";
import { CookieNames, setCookie } from "../helpers/cookie.helper";


function EmailVerification() {
  const { showLoader, hideLoader, showToaster, hideToaster } = useAppContext();
  const [code, setCode] = useState()
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();

  const { user, fetchUserProfile, updateUser } = useUser();

  useEffect(() => {
    if (user.isLoggedIn) {
      navigate("/dashboard", { replace: true });
    }
  }, []);

  const handleSubmit = () => {
    const userdata = { ...data, email: data?.email, code }
    try {
      if (code && code.length !== 0) {
        showLoader();
        LoginVerificationCode(userdata)
          .then(async res => {
            if (res.status === 200) {
              setCookie(CookieNames.LAST_LOGIN_TIME, new Date().toISOString());
              updateUser({ refreshTokenWarningAction: 'REFRESH', timeToLogout: Constants.SESSION_TIMEOUT, isLoggedIn: true });
              // await fetchUserProfile();
              setTimeout(() => {
                navigate("/dashboard", { replace: true });
                hideLoader();
              }, 0);
            }
          }
          ).catch(err => {
            hideLoader();
            showToaster(err.response.data.message, "error");
            setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
            console.log(err, err.response.data.message);
          })
      }
    } catch (error) {
      showToaster("Invalid OTP", "error");
      setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
      hideLoader();
      console.log(error)
    }
  }
  const HandleResendCode = () => {
    showLoader();
    ReSendVerificationCodeEmail(data)
      .then((res) => {
        hideLoader();
        if (res.status === 200) {
          showToaster(res.message, "success");
          setTimeout(() => hideToaster(), Constants.TOASTERHIDETIME);
        }
      }
      )
  }

  return (
    <>
      {/* Main Body */}
      <div className="website-wrap">

        <section className="forgot-body">
          <div className="container">
            <div className="forgot-box verification-box">
              <h4>Email verification</h4>
              <p>
                Please enter verification code sent to {data?.email}
              </p>

              <div className="form-group">
                <label htmlFor="otp-code">Authentication Code</label>
                <input
                  type="number"
                  className="form-control"
                  id="otp-code"
                  aria-describedby="emailHelp"
                  placeholder="Enter a code"
                  onChange={e => setCode(e.target.value)}
                />
              </div>
              <button onClick={handleSubmit} className="btn btn-forgot">
                Submit
              </button>
              <div className="text-center mt-4">
                <a className="link-secondary" onClick={HandleResendCode}>
                  Resend Code
                </a>
              </div>

            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EmailVerification;
